import styled from 'styled-components';
import { Collapse } from 'antd';

export const CollapseStyled = styled(Collapse)`
	border-radius: 0.625rem;

	.ant-collapse-item:last-child {
		border-radius: 0.625rem;

		.ant-collapse-content {
			border-radius: 0 0 0.625rem 0.625rem;
		}
	}
`;
